import React, { useState } from 'react'
import * as QueryString from 'query-string'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { State } from '@rwwa/rwwa-data-access'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { Button } from '@mobi/component-library/Base/Buttons'
import { colors } from '@mobi/component-library/Foundations'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { TabButton, Tabs } from '@mobi/component-library/Navigation/Tabs'
import { MainContainer } from '@core/Components/Containers'
import {
  FavouriteNumbersPools,
  UpcomingFavouriteNumberPools,
  UpcomingPoolsKey,
} from '@core/Data/favouriteNumbers'
import { FavouriteNumberPoolResults } from '@core/Data/favouriteNumbersResults'
import { EasyBetTab } from './EasyBet'
import { NumberResultsTab } from './NumberResultsTab'
import { PotLuckTab } from './PotLuck'
import { selectResultKey } from './Store/selectors'
import { trackFaveNumbersChangeTab } from './analytics'

type Selection = 'easyBet' | 'potLuck' | 'numberResults'
const useQuery = () => QueryString.parse(useLocation().search)

export const FavouriteNumbersPage = (): JSX.Element => {
  const { code = 'easyBet' }: { code: Selection } = useQuery()

  const [selection, setSelection] = useState<Selection>(code)

  const resultKey = useSelector(selectResultKey)

  const handleTabSelection = (tab: Selection) => {
    if (selection !== tab) {
      setSelection(tab)
      let displayLabel: string
      switch (tab) {
        case 'easyBet':
          displayLabel = 'Easy Bet'
          break
        case 'potLuck':
          displayLabel = 'Pot Luck'
          break
        case 'numberResults':
          displayLabel = 'No.s & Results'
          break
        default:
          displayLabel = 'Easy Bet'
      }
      trackFaveNumbersChangeTab(displayLabel)
    }
  }

  const handleRefresh = () => {
    const repo = selection === 'numberResults' ? FavouriteNumberPoolResults : FavouriteNumbersPools
    const key = selection === 'numberResults' ? resultKey : UpcomingPoolsKey
    repo.hardInvalidate(null as unknown as State<UpcomingFavouriteNumberPools>, key)
  }

  return (
    <MainContainer data-tid-favourite-numbers='' background='surface300'>
      <PageHeader
        title='Favourite Numbers'
        rightAlignedComponent={
          <Button size='sm' isIconOnlyButton color='tertiary_dark' onClick={handleRefresh}>
            <Icon name='LineRefreshCw05' color={colors.white} />
          </Button>
        }
      />

      <Tabs bottomBorder='hard'>
        <TabButton
          content='Easy Bet'
          isSelected={selection === 'easyBet'}
          onClick={() => handleTabSelection('easyBet')}
          testId='favnum-easy-bet-tab'
        />
        <TabButton
          content='Pot Luck'
          isSelected={selection === 'potLuck'}
          onClick={() => handleTabSelection('potLuck')}
          testId='favnum-pot-luck-tab'
        />
        <TabButton
          content='NO.S &amp; Results'
          isSelected={selection === 'numberResults'}
          onClick={() => handleTabSelection('numberResults')}
          testId='favnum-results-tab'
        />
      </Tabs>

      {selection === 'numberResults' && <NumberResultsTab />}
      {selection === 'potLuck' && <PotLuckTab />}
      {selection === 'easyBet' && <EasyBetTab />}
    </MainContainer>
  )
}
